import { IUserStoreState } from '@/store/modules/user'
import { useState } from '@/utils/store'
import Vue from 'vue'
import VueRouter, { Route, RouteConfig } from 'vue-router'
import performanceMonitor from "@/utils/performance";
import {trackEvent} from "@/utils/register/omega";

Vue.use(VueRouter)

/**
 * 解决 NavigationDuplicated报错
 */
const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
  return (originalPush.call(this, location) as unknown as Promise<Route>).catch((err: any) => err)
}

const originalReplace = VueRouter.prototype.replace

VueRouter.prototype.replace = function replace(location) {
  return (originalReplace.call(this, location) as unknown as Promise<Route>).catch((err: any) => err)
}

const routes: Array<RouteConfig> = [
  /**
   * 根路由
   */
  {
    path: '/',
    name: 'home',
    component: () => import('../views/home/index.vue')
  },
  /**
   * 错误页
   */
  {
    path: '/error',
    name: 'error',
    component: () => import('../views/error/index.vue')
  },
  /**
   * 牛盾安全拦截页
   */
  {
    path: '/safe-intercept',
    name: 'safety_intercept',
    component: () => import('../views/error/safety-intercept.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login/index.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: '/baldr-outside-app/',
  routes
})

export default router

let isRouterReadyMarked = false;
/**
 * 添加路由认证
 * 已登录后可以路由任意跳转
 * 未登录时去往首页以外的页面，均导航至首页
 */
export const addRouterGuard = () => {
  // 通用错误页面无需登录, 首页有登录判断
  const whiteList = ['error', 'home', 'safety_intercept','login']
  router?.beforeEach((to, from, next) => {
      // 处理性能上报，仅一次
      // 首次路由导航时标记 routerReady
      if (!isRouterReadyMarked) {
          isRouterReadyMarked = true;
          performance.mark('routerReady');

          // 立即计算并上报性能指标
          Vue.nextTick(() => {
              const navEntry = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming;
              if (navEntry && navEntry.responseEnd > 0) {
                  const p2Time = navEntry.responseEnd - navEntry.startTime;
                  const responseEndAbsolute = performance.timeOrigin + navEntry.responseEnd;
                  const routerReadyAbsolute = performance.timeOrigin + performance.now();
                  const p3Time = routerReadyAbsolute - responseEndAbsolute;

                  trackEvent('tech_credit_outside_sw', {
                      event_name: 'metrics_p2',
                      event_duration: Math.round(p2Time),
                  });

                  trackEvent('tech_credit_outside_sw', {
                      event_name: 'metrics_p3',
                      event_duration: Math.round(p3Time),
                  });
              }
          });
      }
    performance.mark('router-before-each')
    const uid = useState<IUserStoreState>('user', ['uid'])?.uid
    if (whiteList.includes(to.name || '') || uid) {
      next()
    } else if (!uid) {
      // 保留参数
      next({
        name: 'home',
        query: to.query
      })
      // next()
    } else {
      next()
    }
  })
}